export let templateSources: { value: number; label: string; img?: string }[] = [
    { value: null, label: "Standard" },

    { value: 10, label: "Backoffice", img: "assets/img/source-icons/RENZ-Icon-Office.svg " },
    { value: 20, label: "eConfig Pro", img: "assets/img/source-icons/RENZ-Icon-ConfigPro.svg" },
    {
        value: 30,
        label: "eConfig",
        img: "assets/img/source-icons/RENZ-Icon-Config.svg",
    },

    { value: 40, label: "RIT", img: "assets/img/source-icons/RENZ-Icon-Rit.svg" },
    { value: 50, label: "eShop", img: "assets/img/source-icons/RENZ-Icon-Shop.svg" },
    { value: 60, label: "eInfo", img: "assets/img/source-icons/RENZ-Icon-eInfo.svg" },
]
